import dayjs from 'dayjs';
import { startCase } from 'lodash';

import type { AssetListDTO } from '@/pages/Assets';
import getDateTime from '@/utils/getDateTime.utils';

import { ASSET_ALERTS_TOPBAR_BOTTOM_VALUES } from './AssetSubTopbarBottom.constants';

const formatAssetDetailsValues = (value: string | number | boolean) => {
  if (!value) return '--';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (
    dayjs.isDayjs(value) ||
    (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value))
  ) {
    // Check to make sure its a date, not a string like "Windows Pro 2022" that just has a date in it
    return getDateTime(value as string);
  }
  return value;
};

export const getSubTopBarBottomData = (assetDetails: AssetListDTO | null) => {
  const assetData = ASSET_ALERTS_TOPBAR_BOTTOM_VALUES.map((key) => {
    const assetKey = key as keyof AssetListDTO;
    const value =
      assetDetails && assetKey in assetDetails
        ? assetDetails[assetKey]
        : undefined;

    return {
      label: startCase(key),
      key,
      value: value
        ? formatAssetDetailsValues(value as string | number | boolean)
        : '--'
    };
  });

  return assetData;
};

export default getSubTopBarBottomData;
